import { useQuery } from '@tanstack/react-query';
import { BreadcrumbsQueryKeys } from '@enums/react-query-keys';
import { Breadcrumb } from '@interfaces/models/breadcrumb';

const useBreadcrumbsQuery = () => {
  const { data: breadcrumbs } = useQuery<Breadcrumb[] | null>({
    queryKey: [BreadcrumbsQueryKeys.BREADCRUMBS],
    staleTime: Infinity,
  });

  return {
    breadcrumbs,
  };
};

export default useBreadcrumbsQuery;
